<app-results-sidebar *ngIf="isLoggedIn() && isProjectLoaded()"></app-results-sidebar>
<app-history-picker *ngIf="showHistoryPicker()"></app-history-picker>
<router-outlet></router-outlet>
